/** Tipos de cadastro de Pessoas */
export enum pessoaTipoCadastro {
    cliente = 1,
    representante = 2,
    transportadora = 3
}
